import { useState } from "react";
import {Navigate} from "react-router-dom";
import CreateTransaction from "./CreateTransaction";
import DeclinedAuthorizations from "./DeclinedAuthorizations";
import PendingAuthorizations from "./PendingAuthorizations";
import MerchantSelection from "./MerchantSelection";
import AccountAuthorisationsSearch from './AccountAuthorisationsSearch';

export default function Authorisations() {
    const [accountIsValid] = useState(true);

    if (!accountIsValid) {
        return <Navigate to={"/accounts/"} />
    }

    return (
        <section>
            <MerchantSelection/>
            <CreateTransaction/>
            <PendingAuthorizations/>
            <DeclinedAuthorizations/>
            <AccountAuthorisationsSearch />
        </section>
    );
}